module.exports = __webpack_public_path__ + "img/tg.6f83dc6a.svg";